<template>
    <v-card outlined >
        <v-card-title class="justify-center font-weight-bold subtitle-2 text-uppercase">{{$t('sum')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-1">
            <v-row>
                <v-col cols="6">
                    <div class="font-weight-bold body-2">{{$t('seller')}}</div>
                </v-col>
                <v-col cols="3">
                    <div class="font-weight-bold body-2">{{$t('quantityCut')}}</div>
                </v-col>
                <v-col cols="3">
                    <div class="font-weight-bold body-2">{{$t('price')}}</div>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="my-1">
            <v-row>
                <v-divider></v-divider>
                <v-col
                        cols="12"
                        v-for="(orderItem, idx) in orderProducts"
                       :key="idx"
                >
                    <order-amount-row :order="orderItem"></order-amount-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-1">
            <v-row class="d-flex align-center">
                <v-col cols="6"><span class="body-2 font-weight-bold">{{ $t('total') }} {{ $t('withoutDelivery') }}:</span></v-col>
                <v-col cols="6" class="text-end subtitle-1">
                    <span class="font-weight-bold">{{ totalPrice ? priceString(totalPrice) : '' }}</span>
                    <span v-if="totalPrice" class="text-lowercase font-weight-bold">{{ $store.getters.currencies[0].cyrName }}</span>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text class="text-center pb-6">
            <!--Mobile and Ipad-->
            <v-btn
                    depressed
                    :disabled="isCheckoutDisabled"
                    class="main--yellow white--text hidden-xs-only hidden-md-and-up"
                    @click="goToCheckout"
                    x-small
            >
                {{ $t('buyAllSellers') }}
            </v-btn>
            <!--Ipad Pro-->
            <v-btn
                    depressed
                    :disabled="isCheckoutDisabled"
                    class="main--yellow white--text hidden-sm-only hidden-lg-and-up"
                    @click="goToCheckout"
                    small
            >
                {{ $t('buyAllSellers') }}
            </v-btn>
            <!--Desktop-->
            <v-btn
                    depressed
                    :disabled="isCheckoutDisabled"
                    class="main--yellow white--text hidden-md-and-down"
                    @click="goToCheckout"
            >
                {{ $t('buyAllSellers') }}
            </v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import DataProvider from '../../../../app-front/mixins/OrderDataProvider';
import OrderAmountRow from './OrderAmountRow';
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "OrderAmount",
    props: [ 'validOrder' ],
    mixins: [
        DataProvider
    ],
    components:{
        OrderAmountRow
    },
    data() {
        return {
            totalPrice: null
        }
    },
    computed: {
        isCheckoutDisabled() {
            return(!this.inProcessProducts || !this.inProcessProducts.length);
        },
        isConfirmDisabled() {
            let disabled = false;

            if(!this.inProcessProducts || !this.inProcessProducts.length) return true;

            this.inProcessProducts.forEach(item => {
                if(!item.paymentWay || !item.date) disabled = true;
            });

            return disabled;
        },
        routeName() {
            return this.$route.name;
        },
    },
    methods: {
        checkoutNBuy() {
            this.$emit('push-confirm');
        },
        calculatePrice() {
            let price = 0;
            this.orderData.inProcess.forEach(item => {
                let orderPrice = 0
                item.products.forEach(product => {
                    orderPrice += product.calculatedPrice;
                });
                if(item.totalDiscount) orderPrice *=(1 - item.totalDiscount / 100);
                price += orderPrice;
            });

            this.totalPrice = price;
        },
        confirmOrder() {
            const emitData = {
                sellers: this.inProcessProducts.map(item => item.sellerID),
                isOpen: true
            };

            this.updateOrderConfirmDialog(emitData);
        },
        goToCheckout() {
            this.$router.push({name: 'checkout'});
        },
        priceString(price) {
            return price ? numberFormat(price, 2, '.', ' ') : 0;
        },
    },
    watch: {
        inProcessProducts: {
            handler() {
                this.calculatePrice();
            },
            deep: true
        }
    },
}
</script>

<style scoped>

</style>
